import { ConferenceRequestInput } from './interface';

export class GetAllRequests {
    static readonly type = '[ConferenceRequests] all';
    constructor(
        public queryParams?: {
            formTitle?: string;
        }
    ) {}
}

export class CreateConferenceForm {
    static readonly type = '[ConferenceRequests] create conference';
    constructor(public input: ConferenceRequestInput) {}
}

export class GetSingleConferenceRequest {
    static readonly type = '[ConferenceRequests] get-one';
    constructor(public id: string) {}
}
export class GetByUser {
    static readonly type = '[ConferenceRequests] get-by-user';
    constructor(public input: { id: string; query: string }) {}
}
export class GetApproverRequests {
    static readonly type = '[ConferenceRequests] approvers';
    constructor(public input: { id: string; query: string }) {}
}
